import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type CreateStageSignoffRequestResponse = {
   signoff_requestid: number;
   userid_requestee: number;
   stage_assessmentid: number;
   created_at: number;
};

export async function createStageSignoffRequest(
   stage_assessmentid: number,
   userid_requestee: number,
   common: CommonRequestOptions = {}
): Promise<CreateStageSignoffRequestResponse> {
   return await makeRequest('post', 'courses/stage-sign-offs/requests', {
      ...common,
      body: {
         stage_assessmentid,
         userid_requestee,
      },
   });
}
